import { RouterPath } from "../assets/dictionary/RouterPath";

function getPathWithSearchHash(locationLike) {
  if (!locationLike) return "";
  const pathname = locationLike.pathname || "";
  const search = locationLike.search || "";
  const hash = locationLike.hash || "";
  return `${pathname}${search}${hash}`;
}

function sanitizeNext(next) {
  if (!next || typeof next !== "string") return null;
  const trimmed = next.trim();
  // Prevent open redirects: only allow internal absolute paths.
  if (!trimmed.startsWith("/")) return null;
  // Prevent protocol-relative redirects like //evil.com
  if (trimmed.startsWith("//")) return null;
  // Extra safety: reject any scheme.
  if (trimmed.includes("://")) return null;
  return trimmed;
}

export function getPostAuthRedirectTarget(location) {
  const from = location?.state?.from;
  const fromTarget = sanitizeNext(getPathWithSearchHash(from));
  if (fromTarget) return fromTarget;

  const search = location?.search || "";
  const params = new URLSearchParams(search);
  const nextParam = sanitizeNext(params.get("next"));
  if (nextParam) return nextParam;

  return RouterPath.HOME;
}

export function buildLoginUrl(next) {
  const safeNext = sanitizeNext(next) || RouterPath.HOME;
  return `${RouterPath.LOGIN}?next=${encodeURIComponent(safeNext)}`;
}

export function buildLoginUrlFromLocation(location) {
  return buildLoginUrl(getPathWithSearchHash(location));
}

